import { useVisitorTracking } from "@/hooks/useVisitorTracking";
import OAuthOnboarding from "@/components/OAuthOnboarding";

const AppInner = ({ children }: { children: React.ReactNode }) => {
  useVisitorTracking();
  return (
    <>
      {children}
      <OAuthOnboarding />
    </>
  );
};

export default AppInner;
